'use strict';

function resizeWindow() {
	//Home arrow position
	$('body#home .arrow-home').css('top', $(window).height() - 50);
	//Home header image
	var sliderH = $(window).height() * 0.9 - 105;
	$('#home .top-content .header-img .sym-slide').height(sliderH);
	//Home portflio slider
	var Hmheight = $('#home .main-content .portfolio-content .portfolio-hotels .slick-center').height() + 60;
	$('#home .main-content .portfolio-content .portfolio-hotels').css('min-height', Hmheight + 'px');
	var activeH = $('#home .main-content .portfolio-content .portfolio-hotels .slick-center').height() + 60;
	$('#home .main-content .portfolio-content .portfolio-hotels .slick-list').height($('#home .main-content .portfolio-content .portfolio-hotels .slick-track').outerHeight());

	//Home portflio hotel slider
	var pheight = $('body.hotel_entry #content .container .hotel-gallery .hotel-photos .slick-center').height() + 60;
	$('body.hotel_entry #content .container .hotel-gallery .hotel-photos').css('min-height', pheight + 'px');
	$('body.hotel_entry #content .container .hotel-gallery .hotel-photos .slick-list').height($('body.hotel_entry #content .container .hotel-gallery .hotel-photos .slick-track').outerHeight());

	//Header elements positioning
	$('#header .menu_btn').width($('#header .btn').outerWidth());
	var lwidth = $('#header .container').width() - ($('#header .menu_btn').outerWidth() + $('#header .btn').outerWidth()) - 12;
	$('#header a.logo').css('width', lwidth + 'px');
	$('#header #primary-nav ul, #header .header_social, #header .header_info').css('left', $('#header .menu_btn').position().left);

	//Portrait view
	if ($(window).width() < 800) {
		//Home titles
		$('body#home .about-content h2, body#home .about-content h3').insertBefore($('body#home .about-content .image'));
		$('body#home .history-content .text').insertAfter($('body#home .history-content .image'));
		$('body#home .history-content h2, body#home .history-content h3').insertBefore($('body#home .history-content .image'));
		//Default
		$('body#default #content .container .title').insertBefore($('body#default #content .container .copy .text'));
	}
}
function scrollDown() {
	var top = $(document).scrollTop();
	if (top > 10) {
		$('#header').addClass('down');
	} else {
		$('#header').removeClass('down');
	}
}

$(window).bind("load", function () {
	$(document).ready(function () {

		//Primary nav layout
		$('#header #primary-nav ul').wrap('<div class="table"></div>');
		$('.header_social, #header .header_info').insertAfter($('#header .table'));

		//Home portfolio carrusel
		var pHotels = $('#home .main-content .portfolio-content .portfolio-hotels').children().length;
		$('#home .main-content .portfolio-content .portfolio-hotels').slick({
			centerMode: true,
			centerPadding: '170px',
			slidesToShow: 1,
			speed: 400,
			dots: true,
			responsive: [{
				breakpoint: 1090,
				settings: {
					centerMode: true,
					centerPadding: '90px',
					slidesToShow: 1
				}
			}, {
				breakpoint: 780,
				settings: {
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 1
				}
			}]
		});

		$('#home .main-content .portfolio-content .portfolio-hotels .slick-dots li button').each(function () {
			var dotT = $(this).text();
			$(this).html(dotT + ' / ' + pHotels);
		});

		//Home testimonials
		var tTestimonials = $('.testimonials-content ul.testimonials').children().length;
		$('#home .testimonials-content ul.testimonials').slick({
			dots: true,
			accessibility: false,
			fade: true,
			cssEase: 'linear'
		});
		$('#home .testimonials-content ul.testimonials .slick-dots li button').each(function () {
			var dotT = $(this).text();
			$(this).html(dotT + ' / ' + tTestimonials);
		});
		//Home Affiliates
		$('#home .main-content .home-affiliates .home-affiliates-block:not(.no-slick)').slick({
			centerMode: true,
			centerPadding: '300px',
			slidesToShow: 1,
			speed: 400,
			accessibility: false,
			responsive: [{
				breakpoint: 780,
				settings: {
					centerMode: true,
					centerPadding: '100px',
					slidesToShow: 1
				}
			}]
		});

		//Portfolio Hotel images slick
		var pPhotos = $('body.hotel_entry #content .container .hotel-gallery .hotel-photos').children().length;
		$('body.hotel_entry #content .container .hotel-gallery .hotel-photos').slick({
			centerMode: true,
			centerPadding: '170px',
			slidesToShow: 1,
			speed: 400,
			dots: true,
			responsive: [{
				breakpoint: 1090,
				settings: {
					centerMode: true,
					centerPadding: '90px',
					slidesToShow: 1
				}
			}, {
				breakpoint: 780,
				settings: {
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 1
				}
			}]
		});
		$('body.hotel_entry #content .container .hotel-gallery .hotel-photos .slick-dots li button').each(function () {
			var dotT = $(this).text();
			$(this).html(dotT + ' / ' + pPhotos);
		});

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		var top = $(document).scrollTop();
		if (top > 10) {
			$('#header').addClass('down');
		} else {
			$('#header').removeClass('down');
		}
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown

		$('.menu_btn').click(showMenu);
		$("#primary-nav li").hover(function () {

			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {

			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function (event) {
			$('body, html').animate({
				scrollTop: $(window).height() - $('header').outerHeight() }, 800, 'easeOutExpo');
		});

		//Slick Slider
		$('.sym-slides').slick();

		//Event Tracking
		$('.book-now').on('click', function () {
			ga('send', 'event', 'reservations', 'click', 'book now');
		});
		$('.bookNow').on('click', function () {
			ga('send', 'event', 'header widget', 'click', 'book now');
		});

		//Check in and check out datepicker for booking engine
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			minDate: 0,
			onSelect: function onSelect(selectedDate) {
				getDate = $(this).datepicker('getDate');
				newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			onSelect: function onSelect(selectedDate) {
				$("#CheckIn").datepicker("option", "maxDate", selectedDate);
			}
		});

		//Gallery loader
		if ($('body#gallery-category').length > 0) {
			setTimeout(function () {
				$('.loader_block').fadeOut(200);
			}, 5000);
		}
		//Portfolio intro text
		if ($('body#portfolio').length > 0) {
			$('body#portfolio #content .container .list .hotel').each(function () {
				if ($(this).find('.info p').text().length > 120) {
					$(this).find('.info p').text($(this).find('.info p').text().substring(0, 120) + '...');
				}
			});
		}
	});
});
function showMenu() {
	$(this).addClass('active');
	$(this).find('.text').html('Close');
	$('#header #primary-nav').addClass('open');
	$(this).unbind('click');
	$(this).click(hideMenu);
}
function hideMenu() {
	$(this).removeClass('active');
	$(this).find('.text').html('Menu');
	$('#header #primary-nav').removeClass('open');
	$(this).unbind('click');
	$(this).click(showMenu);
}